module.exports = __webpack_public_path__ + "img/shape-5.33fd4361.png";